import { Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom'

import AllRequest from './pages/allRequest/view'
import LeaveCalendar from './pages/calendar/view'
import CreditRequest from './pages/leaveCreditRequest/view'
import MyRequest from './pages/myRequest/view'
import LeaveRequestDetails from './pages/requestDetails/view'

import CreateRequestModal from './pages/createRequest/view'
import LeaveCreditDetails from 'module/leave/pages/leaveCreditDetails/view'

import LeaveBalanceDrawer from 'module/leave/pages/leaveBalance/view'
import SubmitCreditDocument from 'module/leave/pages/submitCreditDocument/view'
import CreateCreditRequestDrawer from 'module/leave/pages/createCreditRequest/view'

import PageNotFound404 from 'pages/404/view/PageNotFound404'

const LeaveRoutes = () => {
  let location = useLocation()
  let state = location.state

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route index element={<Navigate to="request" />} />
        <Route path="request" element={<Outlet />}>
          <Route index element={<Navigate to="overview" />} />
          <Route path="overview" element={<MyRequest />} />
          <Route path="all" element={<AllRequest />} />
        </Route>
        <Route index element={<Navigate to="leave_credit" />} />
        <Route path="leave_credit" element={<Outlet />}>
          <Route index element={<Navigate to="overview" />} />
          <Route path="overview" element={<CreditRequest />} />
        </Route>
        <Route path="calendar" element={<LeaveCalendar />} />
        <Route path="*" element={<PageNotFound404 />} />
      </Routes>

      {/* Show the modal when a `backgroundLocation` is set */}
      {state?.backgroundLocation && (
        <Routes>
          <Route path="request" element={<Outlet />}>
            <Route path=":id" element={<LeaveRequestDetails />} />
            <Route
              path="create"
              element={<CreateRequestModal selectedId={state.selectedLeave} />}
            />
            <Route
              path="balance"
              element={
                <LeaveBalanceDrawer
                  leaveBalanceList={state.list}
                  initialSelected={state.initialSelected}
                  backgroundLocation={state.backgroundLocation}
                />
              }
            />
          </Route>
          <Route path="leave_credit" element={<Outlet />}>
            <Route path=":id" element={<LeaveCreditDetails state={state} />}>
              <Route
                path="submitDocument"
                element={<SubmitCreditDocument theItem={state.item} />}
              />
            </Route>
            <Route path="create" element={<CreateCreditRequestDrawer />} />
          </Route>
        </Routes>
      )}
    </>
  )
}

export default LeaveRoutes
